import(/* webpackMode: "eager" */ "/app/src/app/[locale]/[country]/error.tsx");
